import { render, staticRenderFns } from "./SubNotPossibleOverlay.vue?vue&type=template&id=182cc105&scoped=true"
import script from "./SubNotPossibleOverlay.vue?vue&type=script&lang=js"
export * from "./SubNotPossibleOverlay.vue?vue&type=script&lang=js"
import style0 from "./SubNotPossibleOverlay.vue?vue&type=style&index=0&id=182cc105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cc105",
  null
  
)

export default component.exports